import Isotope from 'isotope-layout/js/isotope';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import filterloadMore from "./filter-load-more";

export default () => {
    
    gsap.registerPlugin(ScrollTrigger);

    const filterList = document.querySelectorAll('[filter-list]')

    filterList.length> 0?filterHandle():false;
    
    function filterHandle(){
        filterList.forEach(list => {
           
            let iso = new Isotope( list, {
                itemSelector: '.filter-card',
                layoutMode: 'fitRows',
                hiddenStyle: {
                    opacity: 0
                },
                visibleStyle: {
                    opacity: 1
                },
                
            });
            
            filterloadMore(iso);

            let filterBtn = [...document.querySelectorAll('[filter-btn]')];

            const removeActiveClass = () => {
                filterBtn.forEach(btn => {
                    btn.classList.remove('activities-hero__filter-btn--active')
                })
            };

            filterBtn.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    removeActiveClass();

                    const activityCardsInner = document.querySelector('.activities-cards__inner');
                    if(activityCardsInner) {
                        gsap.to(activityCardsInner, {
                            opacity: 0,
                            duration: 0.3,
                            delay: 0
                        })
            
                        gsap.to(activityCardsInner, {
                            opacity: 1,
                            duration: 2,
                            delay: 0.3
                        })
                    }

                    btn.classList.add('activities-hero__filter-btn--active');
                    let filterData = e.target.getAttribute('data-filter');

                    iso.arrange({
                        filter: filterData
                    });
                    setTimeout(() => {
                        ScrollTrigger.refresh()
                    }, 100);
                   
                })
            })
        })
    }   
    
}